<template>
  <div class="mono-photo-selector">
    <div class="selected-photo-thumbnail-block" v-if="photoObj">
      <span>変更後の写真</span><br/>
      <img class="selected-photo-thumbnail" :src="photoObj.thumbnail" />
    </div>
    <div class="select-photo-controll-block">
      <label :for="photoInputID" onclick="">
        <img src="/images/camera_icon.svg" class="add-photo" @click="selectPhoto"/>
      </label>
      <button class="cancel-btn" v-show="photoObj" @click="cancelSelectPhoto">変更の取消</button>
    </div>
    <input 
      type="file" 
      multiple="multiple" 
      accept="image/*" 
      :id="photoInputID" 
      :name="photoInputID" 
      style="display: none; cursor: pointer;" 
      ref="photoInput" 
      @change="postPhotoChange" />
  </div>
</template>

<script>
import imageCompression from 'browser-image-compression'

export default {
  name: 'MonoPhotoSelector',

  props: {
    photoObj: Object
  },

  emits: [
    'photoSelectedEvent',
    'cancelSelectPhotoEvent',
  ],

  data () {
    return {
      photoInputID: 'photoInputMono'
    }
  },

  computed: {
    inApp () {
      return null
    }
  },

  created () {
    this.initForm()
  },

  methods: {
    initForm () {
      this.photoInputID = 'photoInputMonoSelect' + Math.floor(Math.random() * 10000)
    },

    selectPhoto () {
      if (this.$native.status) {
        this.$native.event('takePhotoEvent', { targetID: this.photoInputID })
      }
    },

    postPhotoChange (event) {
      var selectedFiles = event.target.files
      if (selectedFiles) {
        for (var i = 0; i < selectedFiles.length; i++) {
          this.addSelectedPhoto(selectedFiles[i])
        }
      }
      this.$nextTick(() => {
        this.$refs.photoInput.value = ''
      })
    },

    async addSelectedPhoto (file) {
      this.fixUploadPhoto(file, 300, (obj) => {
        this.$emit('photoSelectedEvent', obj)
      })
    },

    cancelSelectPhoto () {
      this.$emit('cancelSelectPhotoEvent')
    },

    async fixUploadPhoto (file, maxWidthOrHeight, callback) {
      // 圧縮オプションの設定
      // 写真のトリミングはサーバー側で行う。vueでは、トリミング予想をCSSでコントロールして表示する
      const options = {
        maxWidthOrHeight: maxWidthOrHeight
      }
      var obj = {}
      try {
        const compFile = await imageCompression(file, options)
        obj.name = file.name
        obj.orientation = await imageCompression.getExifOrientation(file)
        // canvas作成
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        const image = new Image()
        image.onload = () => {
          console.log('orientation: ' + obj.orientation + 'not fix')
          canvas.height = image.height
          canvas.width = image.width
          context.drawImage(image, 0, 0, image.width, image.height)
          var dataURL = canvas.toDataURL(compFile.type)
          // canvasで修正した画像をサムネイルにセット
          obj.thumbnail = dataURL
          var bin = atob(dataURL.replace(/^.*,/, ''))
          var buffer = new Uint8Array(bin.length)
          for (var i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i)
          }
          try {
            var blob = new Blob([buffer.buffer], {
              type: compFile.type
            })
          } catch (e) {
            console.error(e)
          }
          // blobにしたデータをフォームデータにセット
          obj.uploadFile = blob
          console.log(obj)
          callback(obj)
          // this.$emit('photoSelectedEvent', obj)
        }
        image.src = await imageCompression.getDataUrlFromFile(compFile)
        // console.log(image)

        // canvasで修正したデータをアップロードファイルに入れる
      } catch (error) {
        console.error('image compression error occor.', error)
        throw error
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mono-photo-selector {
  display: flex;
  height: 134px;
  width: 100%;
  .selected-photo-thumbnail-block {
    position: relative;
    width: 115px;
    height: 115px;
    margin: 0;
    margin-right: 10px;
    border: 1px solid #aaa;
    .selected-photo-thumbnail {
      width: 115px;
      height: 115px;
      object-fit: cover;
      border: 1px solid #aaa;
      image-orientation: none;
    }
  }
  .select-photo-controll-block {
    display: flex;
    flex-direction: column;
    @media screen and (min-width: 380px) {
      height: 127px;
      justify-content: flex-end;
    }
    img {
      width: 30px;
    }
    button {
      width: 120px;
      font-size: 14px;
      font-weight: bold;
      border: 1px solid #999;
      border-radius: 3px;
      &.cancel-btn {
        margin-top: 10px;
        background-color: #fff;
        color: #999;
      }
      &.change-btn {
        margin-top: 10px;
        background-color: #999;
        color: #fff;
      }
    }
  }
}
</style>
